import { withTheme } from 'styled-components'
import DesktopNavigation from './DesktopNavigation'

export default withTheme(DesktopNavigation)
